Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var semanticUiReact = require('semantic-ui-react');
var axios = require('axios');
var Overridable = require('react-overridable');
var _pickBy = require('lodash/pickBy');
var _hasIn = require('lodash/hasIn');
var _isEmpty = require('lodash/isEmpty');
var _get = require('lodash/get');
var formik = require('formik');
var _omit = require('lodash/omit');
var _filter = require('lodash/filter');
var _matches = require('lodash/matches');
var _debounce = require('lodash/debounce');
var _uniqBy = require('lodash/uniqBy');
var _isEqual = require('lodash/isEqual');
var queryString = require('query-string');
var tinymceReact = require('@tinymce/tinymce-react');
require('tinymce/tinymce');
require('tinymce/models/dom/model');
require('tinymce/themes/silver');
require('tinymce/icons/default');
require('tinymce/plugins/table');
require('tinymce/plugins/autoresize');
require('tinymce/plugins/code');
require('tinymce/plugins/codesample');
require('tinymce/plugins/image');
require('tinymce/plugins/link');
require('tinymce/plugins/lists');
require('tinymce/plugins/wordcount');
var _isArray = require('lodash/isArray');
var luxon = require('luxon');
var _isNumber = require('lodash/isNumber');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Overridable__default = /*#__PURE__*/_interopDefaultLegacy(Overridable);
var _pickBy__default = /*#__PURE__*/_interopDefaultLegacy(_pickBy);
var _hasIn__default = /*#__PURE__*/_interopDefaultLegacy(_hasIn);
var _isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(_isEmpty);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _omit__default = /*#__PURE__*/_interopDefaultLegacy(_omit);
var _filter__default = /*#__PURE__*/_interopDefaultLegacy(_filter);
var _matches__default = /*#__PURE__*/_interopDefaultLegacy(_matches);
var _debounce__default = /*#__PURE__*/_interopDefaultLegacy(_debounce);
var _uniqBy__default = /*#__PURE__*/_interopDefaultLegacy(_uniqBy);
var _isEqual__default = /*#__PURE__*/_interopDefaultLegacy(_isEqual);
var queryString__default = /*#__PURE__*/_interopDefaultLegacy(queryString);
var _isArray__default = /*#__PURE__*/_interopDefaultLegacy(_isArray);
var _isNumber__default = /*#__PURE__*/_interopDefaultLegacy(_isNumber);

// This file is part of React-Invenio-Forms
class InvenioPopup extends React.Component {
  render() {
    const {
      popupId,
      size,
      trigger,
      content,
      position,
      inverted,
      ariaLabel,
      hoverable
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      id: popupId,
      size: size,
      position: position,
      inverted: inverted,
      hoverable: hoverable,
      on: ["hover", "focus"],
      trigger: /*#__PURE__*/React__default["default"].cloneElement(trigger, {
        "role": "button",
        "tabIndex": 0,
        "aria-label": ariaLabel
      }),
      content: /*#__PURE__*/React__default["default"].createElement("p", {
        role: "tooltip",
        "aria-live": "polite"
      }, content)
    });
  }
}
InvenioPopup.defaultProps = {
  inverted: false,
  position: "top left",
  size: "small",
  hoverable: true
};

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

const _excluded$i = ["alt", "className", "src", "fallbackSrc", "loadFallbackFirst"];

/**
 * Primary UI Image component providing a fallback url if src one is not
 * able to be resolved. This is a thin layer on top of the <img> element.
 */
class Image extends React.Component {
  constructor() {
    super(...arguments);
    this.myRef = /*#__PURE__*/React__default["default"].createRef();
    this.setSrc = function (currentTarget, src) {
      let isFallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (isFallback) {
        if (!currentTarget.classList.contains("fallback_image")) {
          currentTarget.className += " fallback_image";
        }
      } else {
        if (currentTarget.classList.contains("fallback_image")) {
          currentTarget.classList.remove("fallback_image");
        }
      }
      if (currentTarget.nodeName !== "IMG") {
        // Item.Image is wrapping the <img> in a div element
        const img = currentTarget.querySelector("img");
        if (!img) {
          throw Error("No img tag found");
        }
        currentTarget = img;
      }
      currentTarget.src = src;
    };
  }
  async componentDidMount() {
    const {
      fallbackSrc,
      loadFallbackFirst,
      src
    } = this.props;
    if (loadFallbackFirst) {
      try {
        await axios__default["default"].get(src);
        this.setSrc(this.myRef.current, src);
      } catch (error) {
        // Fallback image is already loaded
        console.warn("\n        '".concat(src, "' couldn't be resolved. '").concat(fallbackSrc, "' will be used instead."));
      }
    }
  }
  render() {
    const _this$props = this.props,
      {
        alt,
        className,
        src,
        fallbackSrc,
        loadFallbackFirst
      } = _this$props,
      UIprops = _objectWithoutProperties(_this$props, _excluded$i);
    const loadingClass = !loadFallbackFirst ? "".concat(className, " placeholder") : "".concat(className, " fallback_image");
    const url = loadFallbackFirst ? fallbackSrc : src;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Ref, {
      innerRef: this.myRef
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Image, Object.assign({
      className: loadingClass,
      alt: alt,
      src: url
    }, !loadFallbackFirst && {
      onError: _ref => {
        let {
          currentTarget
        } = _ref;
        currentTarget.onerror = null; // prevents looping
        this.setSrc(currentTarget, fallbackSrc, true);
      },
      onLoad: () => {
        // Control the loader via ref to make it immediately invisible
        if (!loadFallbackFirst) {
          this.myRef.current.classList.remove("placeholder");
        }
      }
    }, UIprops)));
  }
}
Image.defaultProps = {
  className: "",
  alt: "No image found",
  fallbackSrc: "/static/images/square-placeholder.png",
  loadFallbackFirst: false
};

/*
 * // This file is part of React-Invenio-Forms
 * // Copyright (C) 2024 CERN.
 * //
 * // React-Invenio-Forms is free software; you can redistribute it and/or modify it
 * // under the terms of the MIT License; see LICENSE file for more details.
 */
const makeIdEntry = identifier => {
  let icon, link;
  switch (identifier.scheme) {
    case "orcid":
      icon = "/static/images/orcid.svg";
      link = "https://orcid.org/".concat(identifier.identifier);
      break;
    case "gnd":
      icon = "/static/images/gnd-icon.svg";
      link = "https://d-nb.info/gnd/".concat(identifier.identifier);
      break;
    case "ror": // ROR doesn't recommend displaying ROR IDs
    case "isni":
    case "grid":
      return;
    // Skip these schemes
    default:
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, identifier.scheme, ": ", identifier.identifier);
  }
  return /*#__PURE__*/React__default["default"].createElement("span", {
    key: identifier.identifier
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default["default"].createElement(Image, {
    src: icon,
    className: "inline-id-icon mr-5",
    verticalAlign: "middle"
  }), identifier.scheme === "orcid" && identifier.identifier));
};
const makeSubheader = (creatibutor, isOrganization) => {
  if (isOrganization) {
    var _ref, _ref$filter, _creatibutor$types, _creatibutor$types$ma;
    const locationPart = (_ref = [creatibutor === null || creatibutor === void 0 ? void 0 : creatibutor.location_name, creatibutor === null || creatibutor === void 0 ? void 0 : creatibutor.country_name]) === null || _ref === void 0 ? void 0 : (_ref$filter = _ref.filter(Boolean)) === null || _ref$filter === void 0 ? void 0 : _ref$filter.join(", ");
    const typesPart = creatibutor === null || creatibutor === void 0 ? void 0 : (_creatibutor$types = creatibutor.types) === null || _creatibutor$types === void 0 ? void 0 : (_creatibutor$types$ma = _creatibutor$types.map(type => type.charAt(0).toUpperCase() + type.slice(1))) === null || _creatibutor$types$ma === void 0 ? void 0 : _creatibutor$types$ma.join(", ");
    return "".concat(locationPart || "").concat(locationPart && typesPart ? " — " : "").concat(typesPart || "").trim();
  } else {
    var _creatibutor$affiliat, _creatibutor$affiliat2;
    return (creatibutor === null || creatibutor === void 0 ? void 0 : (_creatibutor$affiliat = creatibutor.affiliations) === null || _creatibutor$affiliat === void 0 ? void 0 : (_creatibutor$affiliat2 = _creatibutor$affiliat.map(affiliation => {
      var _affiliation$acronym;
      if (((_affiliation$acronym = affiliation.acronym) === null || _affiliation$acronym === void 0 ? void 0 : _affiliation$acronym.length) > 0) {
        return "".concat(affiliation.name, " (").concat(affiliation.acronym, ")");
      }
      return affiliation.name;
    })) === null || _creatibutor$affiliat2 === void 0 ? void 0 : _creatibutor$affiliat2.join(", ")) || "";
  }
};
const AffiliationsSuggestions = (creatibutors, isOrganization) => {
  const results = creatibutors.map(creatibutor => {
    var _creatibutor$identifi;
    // ensure `affiliations` and `identifiers` are present
    creatibutor.affiliations = creatibutor.affiliations || [];
    creatibutor.identifiers = creatibutor.identifiers || [];
    const subheader = makeSubheader(creatibutor, isOrganization);
    let name = creatibutor.name;
    if (creatibutor.acronym) name += " (".concat(creatibutor.acronym, ")");
    const idString = [];
    (_creatibutor$identifi = creatibutor.identifiers) === null || _creatibutor$identifi === void 0 ? void 0 : _creatibutor$identifi.forEach(i => {
      const idEntry = makeIdEntry(i);
      if (idEntry) idString.push(idEntry);
    });
    return {
      text: creatibutor.name,
      value: creatibutor.id || creatibutor.name,
      name: creatibutor.name,
      extra: creatibutor,
      id: creatibutor.id,
      key: creatibutor.id,
      // Needed by RemoteSelectField to filter out unique values
      content: /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
        id: "ReactInvenioForms.AffiliationsSuggestions.content",
        key: creatibutor.id,
        creatibutor: creatibutor,
        isOrganization: isOrganization,
        idString: idString,
        makeSubheader: makeSubheader,
        makeIdEntry: makeIdEntry
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Header, null, name, " ", idString.length > 0 && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, "(", idString, ")"), subheader.length > 0 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Header.Subheader, null, subheader)))
    };
  });
  return results;
};

class UserListItemCompact extends React.Component {
  render() {
    const {
      id,
      user,
      linkToDetailView
    } = this.props;
    const name = user.profile.full_name || user.username;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item, {
      className: "flex",
      key: id
    }, /*#__PURE__*/React__default["default"].createElement(Image, {
      src: user.links.avatar,
      avatar: true,
      loadFallbackFirst: true
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Content, {
      className: "ml-10"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Header, {
      className: !user.description ? "mt-5" : ""
    }, linkToDetailView ? /*#__PURE__*/React__default["default"].createElement("a", {
      href: linkToDetailView
    }, /*#__PURE__*/React__default["default"].createElement("b", null, name)) : /*#__PURE__*/React__default["default"].createElement("b", null, name), user.type === "group" && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
      className: "ml-10"
    }, "Group"), user.is_current_user && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
      size: "tiny",
      className: "primary ml-10"
    }, "You")), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Meta, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "truncate-lines-1"
    }, " ", user.profile.affiliations))));
  }
}
UserListItemCompact.defaultProps = {
  linkToDetailView: undefined
};

const BulkActionsContext = /*#__PURE__*/React__default["default"].createContext({
  bulkActionContext: {},
  addToSelected: () => {},
  allSelected: false,
  setAllSelected: () => {},
  selectedCount: 0
});

const _excluded$h = ["value"];
class SearchResultsBulkActions extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = () => {
      const {
        setAllSelected,
        allSelected
      } = this.context;
      this.setState({
        allSelectedChecked: !allSelected
      });
      setAllSelected(!allSelected, true);
    };
    this.handleActionOnChange = (e, _ref) => {
      let {
          value
        } = _ref;
        _objectWithoutProperties(_ref, _excluded$h);
      if (!value) return;
      const {
        optionSelectionCallback
      } = this.props;
      const {
        selectedCount,
        bulkActionContext
      } = this.context;
      const selected = _pickBy__default["default"](bulkActionContext, _ref2 => {
        let {
          selected
        } = _ref2;
        return selected === true;
      });
      optionSelectionCallback(value, selected, selectedCount);
    };
    const {
      allSelected: _allSelected
    } = this.props;
    this.state = {
      allSelectedChecked: _allSelected
    };
  }
  componentDidMount() {
    const {
      allSelected
    } = this.context;
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      allSelectedChecked: allSelected
    });
  }
  render() {
    const {
      bulkDropdownOptions
    } = this.props;
    const {
      allSelectedChecked
    } = this.state;
    const {
      allSelected,
      selectedCount
    } = this.context;
    const noneSelected = selectedCount === 0;
    const dropdownOptions = bulkDropdownOptions.map(_ref3 => {
      let {
        key,
        value,
        text
      } = _ref3;
      return {
        key: key,
        value: value,
        text: text,
        disabled: noneSelected
      };
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
      className: "align-self-center mr-10",
      onChange: this.handleOnChange,
      checked: allSelectedChecked && allSelected
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
      className: "align-self-center fluid-responsive",
      text: "".concat(selectedCount, " members selected"),
      options: dropdownOptions,
      "aria-label": "bulk actions",
      item: true,
      selection: true,
      value: null,
      selectOnBlur: false,
      onChange: this.handleActionOnChange,
      selectOnNavigation: false
    }));
  }
}
SearchResultsBulkActions.contextType = BulkActionsContext;
SearchResultsBulkActions.defaultProps = {
  allSelected: false
};

class SearchResultsBulkActionsManager extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.addToSelected = (rowId, data) => {
      const {
        selectedCount
      } = this.state;
      if (_hasIn__default["default"](this.selected, "".concat(rowId))) {
        this.selected[rowId].selected = !this.selected[rowId].selected;
      } else {
        this.selected[rowId].selected = true;
        this.selected[rowId].data = data;
      }
      if (!this.selected[rowId].selected) {
        this.setAllSelected(false);
        this.setSelectedCount(selectedCount - 1);
      } else {
        const updatedCount = selectedCount + 1;
        this.setSelectedCount(updatedCount);
        if (Object.keys(this.selected).length === updatedCount) {
          this.setAllSelected(true);
        }
      }
    };
    this.setSelectedCount = count => {
      this.setState({
        selectedCount: count
      });
    };
    this.setAllSelected = function (val) {
      let global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _this.setState({
        allSelected: val
      });
      if (global) {
        for (const [key] of Object.entries(_this.selected)) {
          _this.selected[key].selected = val;
        }
        if (val) {
          _this.setSelectedCount(Object.keys(_this.selected).length);
        } else {
          _this.setSelectedCount(0);
        }
      }
    };
    this.selected = {};
    this.state = {
      allSelected: false,
      selectedCount: 0
    };
  }
  render() {
    const {
      children
    } = this.props;
    const {
      allSelected,
      selectedCount
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement(BulkActionsContext.Provider, {
      value: {
        bulkActionContext: this.selected,
        addToSelected: this.addToSelected,
        setAllSelected: this.setAllSelected,
        allSelected: allSelected,
        selectedCount: selectedCount
      }
    }, children);
  }
}
SearchResultsBulkActionsManager.contextType = BulkActionsContext;

class SearchResultsRowCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.isChecked = (bulkActionContext, allSelected) => {
      const {
        rowId
      } = this.props;
      if (_hasIn__default["default"](bulkActionContext, "".concat(rowId)) || allSelected) {
        return bulkActionContext[rowId].selected;
      }
      return false;
    };
    this.subscribeToContext = () => {
      const {
        rowId,
        data
      } = this.props;
      const {
        allSelected,
        bulkActionContext
      } = this.context;
      if (!_hasIn__default["default"](bulkActionContext, "".concat(rowId))) {
        bulkActionContext[rowId] = {
          selected: allSelected,
          data: data
        };
      }
    };
    this.handleOnChange = () => {
      const {
        addToSelected
      } = this.context;
      const {
        rowId,
        data
      } = this.props;
      const {
        isChecked
      } = this.state;
      this.setState({
        isChecked: !isChecked
      });
      addToSelected(rowId, data);
    };
    this.state = {
      isChecked: false
    };
  }
  componentDidMount() {
    this.subscribeToContext();
    const {
      bulkActionContext,
      allSelected
    } = this.context;
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      isChecked: this.isChecked(bulkActionContext, allSelected)
    });
  }
  render() {
    const {
      bulkActionContext,
      allSelected
    } = this.context;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
      className: "mt-auto mb-auto ",
      checked: this.isChecked(bulkActionContext, allSelected) || allSelected,
      onChange: this.handleOnChange
    });
  }
}
SearchResultsRowCheckbox.contextType = BulkActionsContext;

class GridResponsiveSidebarColumn extends React__default["default"].Component {
  render() {
    const closeSidebarBtnRef = /*#__PURE__*/React__default["default"].createRef();
    const {
      mobile,
      tablet,
      computer,
      widescreen,
      largeScreen,
      width,
      open,
      onHideClick,
      children,
      ariaLabel
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      as: "aside",
      "aria-label": ariaLabel,
      mobile: mobile,
      tablet: tablet,
      width: width,
      only: "mobile tablet"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Sidebar, {
      as: semanticUiReact.Segment,
      animation: "overlay",
      visible: open,
      width: "wide",
      onHide: onHideClick,
      onShow: () => closeSidebarBtnRef.current.focus()
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      basic: true,
      icon: "close",
      size: "small",
      floated: "right",
      onClick: onHideClick,
      "aria-label": "Close filter",
      ref: closeSidebarBtnRef,
      className: "mb-20"
    }), children)), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      as: "aside",
      "aria-label": ariaLabel,
      width: width,
      only: "computer",
      computer: computer,
      largeScreen: largeScreen,
      widescreen: widescreen
    }, children));
  }
}
GridResponsiveSidebarColumn.defaultProps = {
  width: undefined,
  mobile: undefined,
  tablet: undefined,
  computer: undefined,
  widescreen: undefined,
  largeScreen: undefined,
  ariaLabel: undefined
};

const _excluded$g = ["header", "errors", "content", "icon"];
const FieldErrorList = _ref => {
  let {
    fieldErrors
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.List, null, fieldErrors.map(error => {
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Item, {
      key: error
    }, error.field && error.field !== "_schema" && /*#__PURE__*/React__default["default"].createElement("strong", null, error.field, ": "), error.message ? error.message : error.messages && error.messages.length === 1 ? error.messages[0] : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.List, null, error.messages.map(message => /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Item, {
      key: message
    }, message))));
  }));
};
/**
 * General component for error messages.
 * Handles:
 *   - simple error messages: provide custom header, and content - response message of received error;
 *   - complex error messages: provide list or received errors.
 * Icon and other ui props are supported.
 */
class ErrorMessage extends React.Component {
  render() {
    const _this$props = this.props,
      {
        header,
        errors,
        content,
        icon
      } = _this$props,
      uiProps = _objectWithoutProperties(_this$props, _excluded$g);
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message, Object.assign({
      icon: Boolean(icon)
    }, uiProps), icon && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: icon
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Content, {
      role: "alert"
    }, header && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Header, null, header), content, !_isEmpty__default["default"](errors) && /*#__PURE__*/React__default["default"].createElement(FieldErrorList, {
      fieldErrors: errors
    })));
  }
}
ErrorMessage.defaultProps = {
  errors: undefined,
  header: undefined,
  uiProps: undefined,
  icon: undefined,
  content: undefined
};

// This file is part of React-Invenio-Forms
class AccordionError extends React.Component {
  constructor(_props) {
    super(_props);
    this.getSubfieldErrors = props => {
      const {
        includesPaths
      } = this.props;
      const {
        form: {
          errors,
          initialErrors
        }
      } = props;
      const subfieldErrors = [];
      for (const fieldPath of includesPaths) {
        const err = _get__default["default"](errors, fieldPath) || _get__default["default"](initialErrors, fieldPath);
        if (err) {
          if (typeof err == "object") {
            const errs = this.findErrorObjects(err);
            subfieldErrors.push(...errs);
          } else {
            subfieldErrors.push(err);
          }
        }
      }
      return subfieldErrors;
    };
    this.categorizeErrors = errors => {
      const categories = {
        info: [],
        warning: [],
        error: []
      };
      for (const err of errors) {
        if (!Object.prototype.hasOwnProperty.call(err, "severity")) {
          categories.error.push(err);
        } else {
          categories["".concat(err.severity)].push(err);
        }
      }
      return categories;
    };
    this.state = {
      errors: undefined
    };
  }
  componentDidMount() {
    const {
      formProps,
      hasError
    } = this.props;
    const subfieldErrors = this.getSubfieldErrors(formProps);
    const categorizedErrors = this.categorizeErrors(subfieldErrors);
    hasError(categorizedErrors);
    this.setState({
      errors: categorizedErrors
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      formProps: {
        form: {
          errors,
          initialErrors
        }
      },
      formProps,
      hasError
    } = this.props;
    if (prevProps.formProps.form.errors !== errors || prevProps.formProps.form.initialErrors !== initialErrors) {
      const subfieldErrors = this.getSubfieldErrors(formProps);
      const categorizedErrors = this.categorizeErrors(subfieldErrors);
      hasError(categorizedErrors);
      this.setState({
        errors: categorizedErrors
      });
    }
  }
  findErrorObjects(obj) {
    const results = [];
    function traverse(current) {
      if (typeof current !== "object" || current === null) {
        return;
      }
      if ("message" in current && "severity" in current) {
        results.push(current);
      }
      Object.keys(current).forEach(key => {
        traverse(current[key]);
      });
    }
    traverse(obj);
    return results;
  }
  severityLabel(severity, severityChecks) {
    var _severityCheck$label;
    if (severityChecks == null) return severity;
    const severityCheck = severityChecks[severity];
    return (_severityCheck$label = severityCheck === null || severityCheck === void 0 ? void 0 : severityCheck.label) !== null && _severityCheck$label !== void 0 ? _severityCheck$label : severity;
  }
  render() {
    const {
      errors
    } = this.state;
    const {
      severityChecks
    } = this.props;
    if (errors === undefined) {
      return null;
    }
    return Object.entries(errors).map(_ref => {
      let [severity, messages] = _ref;
      return !_isEmpty__default["default"](messages) && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
        key: severity,
        size: "tiny",
        circular: true,
        className: "accordion-label ".concat(severity)
      }, messages.length, " ", this.severityLabel(severity, severityChecks), messages.length > 1 ? "s" : "");
    });
  }
}
AccordionError.defaultProps = {
  severityChecks: null
};
class AccordionField extends React.Component {
  constructor(_props2) {
    super(_props2);
    this.handleTitleClick = (e, _ref2) => {
      let {
        index
      } = _ref2;
      const {
        activeIndex
      } = this.state;
      this.setState({
        activeIndex: activeIndex === index ? -1 : index
      });
    };
    this.hasError = categorizedErrors => {
      const hasError = categorizedErrors.error.length > 0;
      this.setState({
        hasError: hasError
      });
    };
    this.renderAccordion = props => {
      const {
        label,
        children,
        includesPaths,
        severityChecks
      } = this.props;
      const {
        hasError,
        activeIndex
      } = this.state;
      const uiProps = _omit__default["default"](this.props, ["optimized", "includesPaths"]);

      // Determine if the accordion should show an "error" state
      const errorClass = hasError ? "error" : "";
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Accordion, Object.assign({
        inverted: true,
        className: "invenio-accordion-field ".concat(errorClass, " secondary")
      }, uiProps), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Accordion.Title, {
        active: activeIndex === 0,
        index: 0,
        onClick: this.handleTitleClick,
        onKeyDown: e => {
          if (e.key === "Enter" || e.key === " ") {
            this.handleTitleClick(e, {
              index: 0
            });
          }
        },
        tabIndex: 0
      }, label, /*#__PURE__*/React__default["default"].createElement(AccordionError, {
        hasError: this.hasError,
        formProps: props,
        includesPaths: includesPaths,
        severityChecks: severityChecks
      }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "caret right"
      })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Accordion.Content, {
        active: activeIndex === 0
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Container, null, children)));
    };
    const {
      active
    } = this.props;
    this.state = {
      hasError: false,
      activeIndex: active ? 0 : -1
    };
  }
  render() {
    const {
      optimized
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      name: "",
      component: this.renderAccordion
    });
  }
}
AccordionField.defaultProps = {
  active: true,
  includesPaths: [],
  label: "",
  optimized: false,
  children: null,
  ui: null,
  severityChecks: null
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

// This file is part of React-Invenio-Forms
class FieldLabel extends React.Component {
  render() {
    const {
      htmlFor,
      icon,
      label,
      className
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: htmlFor,
      className: className
    }, icon ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: icon
    }) : null, label);
  }
}
FieldLabel.defaultProps = {
  className: "field-label-class invenio-field-label",
  icon: "",
  htmlFor: undefined,
  label: undefined
};

const _excluded$f = ["form"],
  _excluded2$6 = ["addButtonLabel", "addButtonClassName", "children", "defaultNewValue", "fieldPath", "label", "labelIcon", "helpText", "requiredOptions", "showEmptyValue"];
class ArrayField extends React.Component {
  constructor(_props) {
    super(_props);
    this.hasGroupErrors = errors => {
      const {
        fieldPath
      } = this.props;
      for (const field in errors) {
        if (field.startsWith(fieldPath)) {
          return true;
        }
      }
      return false;
    };
    /**
     * Returns the array of values to display, it checks for required options and adds empty rows with the required values prefilled
     * @param {Array} values The array of values
     * @param {String} fieldPath The path of the field
     * @returns An array of values to display
     */
    this.getValues = (values, fieldPath) => {
      const {
        requiredOptions,
        defaultNewValue,
        showEmptyValue
      } = this.props;
      const {
        hasBeenShown
      } = this.state;
      const existingValues = formik.getIn(values, fieldPath, []);
      if (!hasBeenShown && _isEmpty__default["default"](requiredOptions) && _isEmpty__default["default"](existingValues) && showEmptyValue) {
        existingValues.push(_objectSpread2({
          __key: existingValues.length
        }, defaultNewValue));
        this.setState({
          hasBeenShown: true
        });
      }
      for (const requiredOption of requiredOptions) {
        const valuesMatchingRequiredOption = _filter__default["default"](existingValues, _matches__default["default"](requiredOption));
        if (valuesMatchingRequiredOption.length === 0) {
          existingValues.push(_objectSpread2({
            __key: existingValues.length
          }, requiredOption));
        }
      }
      return existingValues;
    };
    this.renderFormField = props => {
      const {
          form: {
            values,
            errors
          }
        } = props,
        arrayHelpers = _objectWithoutProperties(props, _excluded$f);
      const _this$props = this.props,
        {
          addButtonLabel,
          addButtonClassName,
          children,
          defaultNewValue,
          fieldPath,
          label,
          labelIcon,
          helpText,
          requiredOptions,
          showEmptyValue
        } = _this$props,
        uiProps = _objectWithoutProperties(_this$props, _excluded2$6);
      const hasError = this.hasGroupErrors(errors) ? {
        error: {}
      } : {};
      const {
        nextKey
      } = this.state;
      const valuesToDisplay = this.getValues(values, fieldPath);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, Object.assign({}, uiProps, hasError), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
        className: "helptext"
      }, helpText), /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      }), valuesToDisplay.map((value, index, array) => {
        const arrayPath = fieldPath;
        const indexPath = index;
        const key = value.__key || index;
        return /*#__PURE__*/React__default["default"].createElement("div", {
          key: key
        }, children(_objectSpread2({
          array,
          arrayHelpers,
          arrayPath,
          indexPath,
          key,
          value
        }, props)));
      }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Button, {
        type: "button",
        icon: true,
        className: addButtonClassName,
        labelPosition: "left",
        onClick: () => {
          arrayHelpers.push(_objectSpread2(_objectSpread2({}, defaultNewValue), {}, {
            __key: nextKey
          }));
          this.setState(state => ({
            nextKey: state.nextKey - 1
          }));
        }
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "add"
      }), addButtonLabel)));
    };
    this.state = {
      // Chosen because it will never cross with 0-indexed pre-existing keys.
      nextKey: -1,
      hasBeenShown: false
    };
  }
  render() {
    const {
      fieldPath
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(formik.FieldArray, {
      className: "invenio-array-field",
      name: fieldPath,
      id: fieldPath,
      component: this.renderFormField
    });
  }
}
ArrayField.defaultProps = {
  addButtonLabel: "Add new row",
  addButtonClassName: "align-self-end mt-15",
  helpText: "",
  label: "",
  labelIcon: "",
  requiredOptions: [],
  showEmptyValue: false
};

// This file is part of React-Invenio-Forms
class BaseForm extends React.Component {
  render() {
    const {
      formik: formik$1,
      onSubmit,
      children
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(formik.Formik, Object.assign({
      onSubmit: onSubmit
    }, formik$1), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form, null, children));
  }
}
BaseForm.defaultProps = {
  formik: undefined
};

const _excluded$e = ["fieldPath", "label"];
class BooleanField extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = props => {
      const _this$props = this.props,
        {
          fieldPath,
          label
        } = _this$props,
        uiProps = _objectWithoutProperties(_this$props, _excluded$e);
      const {
        form: {
          values,
          handleBlur,
          errors,
          initialErrors,
          initialValues,
          setFieldValue
        }
      } = props;
      const value = formik.getIn(values, fieldPath, false);
      const initialValue = formik.getIn(initialValues, fieldPath, false);
      // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      const fieldErrors = errors || initialValue === value && initialErrors;
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
        inline: true
      }, /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: fieldPath
      }, label), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Checkbox, Object.assign({
        id: fieldPath,
        name: fieldPath,
        onChange: () => setFieldValue(fieldPath, !value),
        onBlur: handleBlur,
        checked: value,
        error: this.renderError(fieldErrors, fieldPath)
      }, uiProps)));
    };
  }
  renderError(errors, name) {
    let direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left";
    const error = errors[name];
    return error ? {
      content: error,
      pointing: direction
    } : null;
  }
  render() {
    const {
      optimized,
      fieldPath
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      className: "invenio-boolean-field",
      name: fieldPath,
      component: this.renderFormField
    });
  }
}
BooleanField.defaultProps = {
  label: "",
  optimized: false
};

const _excluded$d = ["fieldPath"];
class ErrorLabel extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = _ref => {
      let {
        form: {
          errors,
          initialErrors
        }
      } = _ref;
      const _this$props = this.props,
        {
          fieldPath
        } = _this$props,
        uiProps = _objectWithoutProperties(_this$props, _excluded$d);
      const error = _get__default["default"](errors, fieldPath, "") || _get__default["default"](initialErrors, fieldPath, "");
      return error ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, Object.assign({
        pointing: true,
        prompt: true,
        content: error
      }, uiProps)) : null;
    };
  }
  render() {
    const {
      fieldPath
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      className: "invenio-error-label-field",
      name: fieldPath
    }, this.renderFormField);
  }
}

// This file is part of React-Invenio-Forms
class FeedbackLabel extends React.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    this.getAllErrSubPaths = function (obj) {
      let prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      const result = [];
      for (let k in obj) {
        let path = prev + (prev ? "." : "") + k;

        // find leaf path of errors
        if (typeof obj[k] == "string" || obj[k].severity !== undefined) {
          result.push(path);
        } else if (typeof obj[k] == "object") {
          result.push(..._this.getAllErrSubPaths(obj[k], path));
        }
      }
      return result;
    };
    this.computeErrors = (errors, initialErrors) => {
      const {
        fieldPath,
        injectedError,
        hasSubfields
      } = this.props;
      let error;
      if (injectedError) {
        error = injectedError;
      } else {
        error = _get__default["default"](errors, fieldPath, "") || _get__default["default"](initialErrors, fieldPath, "");
        if (hasSubfields) {
          // handle nested fields & their errors
          const errorPaths = this.getAllErrSubPaths(error);
          if (!_isEmpty__default["default"](errorPaths)) {
            // we display only first error, there is no good way to display all of them
            // when multiple errors on one field happen
            error = _get__default["default"](error, errorPaths[0], "");
          }
        }
      }
      const hasSeverity = Object.prototype.hasOwnProperty.call(error, "severity");
      let errorMessage;
      if (hasSeverity) {
        errorMessage = error.message;
      } else if (!hasSeverity && !hasSubfields && typeof error === "object") {
        // this case will be for nested field error,
        // which should not display on the top level of the feedback label
        errorMessage = null;
      } else {
        errorMessage = error;
      }
      return {
        error: error,
        errMessage: errorMessage,
        hasSeverity: hasSeverity
      };
    };
    this.renderErrors = _ref => {
      let {
        form: {
          errors,
          initialErrors
        }
      } = _ref;
      const {
        fieldPath,
        pointing
      } = this.props;
      const {
        error,
        errMessage,
        hasSeverity
      } = this.computeErrors(errors, initialErrors);
      if (errMessage === null) {
        return null;
      }
      const isError = !hasSeverity || error.severity === "error";
      const icon = isError ? "times circle" : "info circle";
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
        pointing: pointing,
        className: isError ? "prompt" : error.severity
      }, hasSeverity && /*#__PURE__*/React__default["default"].createElement(InvenioPopup, {
        popupId: "invenio-form-feedback-error-".concat(fieldPath),
        ariaLabel: "Form field feedback error",
        trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
          name: icon
        })
        // Rule descriptions can contain HTML to link to a page with more details about the rule.
        // This field is sanitized in the backend with SanitizedHTML.
        ,
        content: /*#__PURE__*/React__default["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: error.description
          }
        }),
        position: "top center",
        hoverable: true
      }), errMessage);
    };
  }
  render() {
    const {
      fieldPath
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      className: "invenio-error-label-field",
      name: fieldPath
    }, this.renderErrors);
  }
}
FeedbackLabel.defaultProps = {
  injectedError: undefined,
  pointing: "left",
  fieldPath: undefined,
  hasSubfields: false
};

const _excluded$c = ["action", "basic", "border", "children", "fieldPath"],
  _excluded2$5 = ["optimized", "fieldPath"];
class GroupField extends React__default["default"].Component {
  constructor() {
    super(...arguments);
    this.hasGroupErrors = errors => {
      const {
        fieldPath
      } = this.props;
      for (const field in errors) {
        if (field.startsWith(fieldPath)) {
          return true;
        }
      }
      return false;
    };
    this.renderBasicField = (action, classNames, children) => {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: classNames.join(" ")
      }, action && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "group-action"
      }, action), children);
    };
    this.renderFormField = props => {
      const {
          action,
          basic,
          border,
          children,
          fieldPath
        } = props,
        uiProps = _objectWithoutProperties(props, _excluded$c);
      const errors = formik.getIn(props, "form.errors");
      const classNames = ["form-group"];
      if (border) {
        classNames.push("border");
      }
      if (fieldPath && this.hasGroupErrors(errors)) {
        classNames.push("error");
      }
      if (basic) {
        return this.renderBasicField(action, classNames, children);
      }
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, Object.assign({
        className: classNames.join(" ")
      }, uiProps), action && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "group-action"
      }, action), children);
    };
  }
  render() {
    const _this$props = this.props,
      {
        optimized,
        fieldPath
      } = _this$props,
      uiProps = _objectWithoutProperties(_this$props, _excluded2$5);
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, Object.assign({
      name: fieldPath,
      component: this.renderFormField,
      fieldPath: fieldPath,
      className: "invenio-group-field"
    }, uiProps));
  }
}
GroupField.defaultProps = {
  border: false,
  fieldPath: "",
  optimized: false,
  action: undefined,
  basic: false,
  children: undefined
};

const _excluded$b = ["form"],
  _excluded2$4 = ["defaultValue", "error", "fieldPath", "label", "options", "onChange", "onAddItem", "multiple", "disabled", "required"],
  _excluded3$2 = ["optimized", "fieldPath", "helpText"];
class SelectField extends React.Component {
  constructor() {
    super(...arguments);
    this.renderError = (meta, initialValue, initialErrors, value, errors) => {
      const {
        error,
        fieldPath
      } = this.props;
      const computedError = error || formik.getIn(errors, fieldPath, null) ||
      // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      initialValue === value && formik.getIn(initialErrors, fieldPath, null);
      return computedError && /*#__PURE__*/React__default["default"].createElement(FeedbackLabel, {
        errorMessage: computedError,
        pointing: "above",
        fieldPath: fieldPath
      });
    };
    this.renderFormField = formikProps => {
      const {
          form: {
            values,
            setFieldValue,
            handleBlur,
            errors,
            initialErrors,
            initialValues,
            meta
          }
        } = formikProps,
        cmpProps = _objectWithoutProperties(formikProps, _excluded$b);
      const {
          defaultValue,
          error,
          fieldPath,
          label,
          options,
          onChange,
          onAddItem,
          multiple,
          disabled,
          required
        } = cmpProps,
        uiProps = _objectWithoutProperties(cmpProps, _excluded2$4);
      const _defaultValue = multiple ? [] : "";
      const value = formik.getIn(values, fieldPath, defaultValue || _defaultValue);
      const initialValue = formik.getIn(initialValues, fieldPath, _defaultValue);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Dropdown, Object.assign({
        fluid: true,
        className: "invenio-select-field",
        search: true,
        selection: true,
        error: this.renderError(meta, initialValue, initialErrors, value, errors),
        label: {
          children: label
        },
        name: fieldPath,
        disabled: disabled,
        required: required,
        onBlur: handleBlur,
        onChange: (event, data) => {
          if (onChange) {
            onChange({
              event,
              data,
              formikProps
            });
            event.target.value = "";
          } else {
            setFieldValue(fieldPath, data.value);
          }
        },
        onAddItem: (event, data) => {
          if (onAddItem) {
            onAddItem({
              event,
              data,
              formikProps
            });
          }
        },
        options: options,
        value: value,
        multiple: multiple,
        selectOnBlur: false
      }, uiProps));
    };
  }
  render() {
    const _this$props = this.props,
      {
        optimized,
        fieldPath,
        helpText
      } = _this$props,
      uiProps = _objectWithoutProperties(_this$props, _excluded3$2);
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FormikField, Object.assign({
      name: fieldPath,
      component: this.renderFormField,
      fieldPath: fieldPath
    }, uiProps)), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, helpText));
  }
}
SelectField.defaultProps = {
  defaultValue: "",
  optimized: false,
  error: undefined,
  label: "",
  onChange: undefined,
  onAddItem: undefined,
  multiple: false,
  helpText: undefined,
  required: false,
  disabled: false
};

// This file is part of React-Invenio-Forms
const baseAxiosConfiguration = {
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
  headers: {
    "Accept": "application/vnd.inveniordm.v1+json",
    "Content-Type": "application/json"
  }
};
const http = axios__default["default"].create(baseAxiosConfiguration);

// This file is part of React-Invenio-Forms
// Copyright (C) 2022 CERN.
//
// React-Invenio-Forms is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Wrap a promise to be cancellable and avoid potential memory leaks
 * https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
 * @param promise the promise to wrap
 * @returns {Object} an object containing the promise to resolve and a `cancel` fn to reject the promise
 */
const withCancel = promise => {
  let isCancelled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(val => isCancelled ? reject("UNMOUNTED") : resolve(val), error => isCancelled ? reject("UNMOUNTED") : reject(error));
  });
  return {
    promise: wrappedPromise,
    cancel() {
      isCancelled = true;
    }
  };
};

const _excluded$a = ["options", "value"],
  _excluded2$3 = ["fieldPath", "suggestionAPIUrl", "suggestionAPIQueryParams", "serializeSuggestions", "serializeAddedValue", "suggestionAPIHeaders", "debounceTime", "searchQueryParamName", "noResultsMessage", "loadingMessage", "suggestionsErrorMessage", "noQueryMessage", "initialSuggestions", "preSearchChange", "onValueChange", "search", "isFocused"];
const DEFAULT_SUGGESTION_SIZE = 20;
const serializeSuggestions = suggestions => suggestions.map(item => ({
  text: item.title,
  value: item.id,
  key: item.id
}));
class RemoteSelectField extends React.Component {
  constructor(props) {
    super(props);
    this.onSelectValue = async (event, _ref, callbackFunc) => {
      let {
          options,
          value
        } = _ref;
        _objectWithoutProperties(_ref, _excluded$a);
      const {
        multiple
      } = this.props;
      const newSelectedSuggestions = options.filter(item => {
        if (multiple) {
          // "value" is an array so check if it includes the option's value
          return value.includes(item.value);
        } else {
          // "value" is a string so we just compare directly
          return item.value === value;
        }
      });
      this.setState({
        selectedSuggestions: newSelectedSuggestions,
        searchQuery: null,
        error: false,
        open: !!multiple
      }, () => callbackFunc(newSelectedSuggestions));
      await this.searchIfNoSuggestions(newSelectedSuggestions); // Reset search query to empty string after selection
    };
    this.handleAddition = async (e, _ref2, callbackFunc) => {
      let {
        value
      } = _ref2;
      const {
        serializeAddedValue
      } = this.props;
      const {
        selectedSuggestions
      } = this.state;
      const selectedSuggestion = serializeAddedValue ? serializeAddedValue(value) : {
        text: value,
        value,
        key: value,
        name: value
      };
      const newSelectedSuggestions = [...selectedSuggestions, selectedSuggestion];
      this.setState(prevState => ({
        selectedSuggestions: newSelectedSuggestions,
        suggestions: _uniqBy__default["default"]([...prevState.suggestions, ...newSelectedSuggestions], "value"),
        searchQuery: null
      }), () => callbackFunc(newSelectedSuggestions));
      await this.searchIfNoSuggestions(newSelectedSuggestions); // Reset search query to empty string after addition
    };
    this.onSearchChange = _debounce__default["default"](async (e, _ref3) => {
      let {
        searchQuery
      } = _ref3;
      this.cancellableAction && this.cancellableAction.cancel();
      await this.executeSearch(searchQuery);
      // eslint-disable-next-line react/destructuring-assignment
    }, this.props.debounceTime);
    // can't destructure as prop variable is used outside the inner function
    this.executeSearch = async searchQuery => {
      const {
        preSearchChange,
        serializeSuggestions
      } = this.props;
      const query = preSearchChange(searchQuery);
      // If there is no query change, then display prevState suggestions
      const {
        searchQuery: prevSearchQuery
      } = this.state;
      if (prevSearchQuery === query) {
        return;
      }
      this.setState({
        isFetching: true,
        searchQuery: query
      });
      try {
        const suggestions = await this.fetchSuggestions(query);
        const serializedSuggestions = serializeSuggestions(suggestions);
        this.setState(prevState => ({
          suggestions: _uniqBy__default["default"]([...prevState.selectedSuggestions, ...serializedSuggestions], "key"),
          isFetching: false,
          error: false,
          open: true
        }));
      } catch (e) {
        console.error(e);
        this.setState({
          error: true,
          isFetching: false
        });
      }
    };
    this.searchIfNoSuggestions = async newSelectedSuggestions => {
      // If all the suggestions from the search query are selected, fetch all suggestions via API
      const {
        suggestions
      } = this.state;
      if (_isEqual__default["default"](newSelectedSuggestions, suggestions)) {
        await this.executeSearch("");
      }
    };
    this.fetchSuggestions = async searchQuery => {
      const {
        suggestionAPIUrl,
        suggestionAPIQueryParams,
        suggestionAPIHeaders,
        searchQueryParamName
      } = this.props;
      this.cancellableAction = withCancel(axios__default["default"].get(suggestionAPIUrl, {
        params: _objectSpread2({
          [searchQueryParamName]: searchQuery,
          size: DEFAULT_SUGGESTION_SIZE
        }, suggestionAPIQueryParams),
        headers: suggestionAPIHeaders,
        // There is a bug in axios that prevents brackets from being encoded,
        // remove the paramsSerializer when fixed.
        // https://github.com/axios/axios/issues/3316
        paramsSerializer: params => queryString__default["default"].stringify(params, {
          arrayFormat: "repeat"
        })
      }));
      try {
        var _response$data, _response$data$hits;
        const response = await this.cancellableAction.promise;
        return response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$hits = _response$data.hits) === null || _response$data$hits === void 0 ? void 0 : _response$data$hits.hits;
      } catch (e) {
        console.error(e);
      }
    };
    this.getNoResultsMessage = () => {
      const {
        loadingMessage,
        suggestionsErrorMessage,
        noQueryMessage,
        noResultsMessage
      } = this.props;
      const {
        isFetching,
        error,
        searchQuery
      } = this.state;
      if (isFetching) {
        return loadingMessage;
      }
      if (error) {
        return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message, {
          negative: true,
          size: "mini",
          content: suggestionsErrorMessage
        });
      }
      if (!searchQuery) {
        return noQueryMessage;
      }
      return noResultsMessage;
    };
    this.onClose = () => {
      this.setState({
        open: false
      });
    };
    this.onBlur = () => {
      const {
        searchOnFocus
      } = this.props;
      this.setState(prevState => ({
        open: false,
        error: false,
        searchQuery: searchOnFocus ? prevState.searchQuery : null,
        suggestions: searchOnFocus ? prevState.suggestions : prevState.selectedSuggestions
      }));
    };
    this.onFocus = async () => {
      this.setState({
        open: true
      });
      const {
        searchOnFocus
      } = this.props;
      if (searchOnFocus) {
        const {
          searchQuery
        } = this.state;
        await this.executeSearch(searchQuery || "");
      }
    };
    this.getProps = () => {
      const _this$props = this.props,
        {
          fieldPath,
          suggestionAPIUrl,
          suggestionAPIQueryParams,
          serializeSuggestions,
          serializeAddedValue,
          suggestionAPIHeaders,
          debounceTime,
          searchQueryParamName,
          noResultsMessage,
          loadingMessage,
          suggestionsErrorMessage,
          noQueryMessage,
          initialSuggestions,
          preSearchChange,
          onValueChange,
          search,
          isFocused
        } = _this$props,
        uiProps = _objectWithoutProperties(_this$props, _excluded2$3);
      const compProps = {
        fieldPath,
        suggestionAPIUrl,
        suggestionAPIQueryParams,
        suggestionAPIHeaders,
        serializeSuggestions,
        serializeAddedValue,
        debounceTime,
        searchQueryParamName,
        noResultsMessage,
        loadingMessage,
        suggestionsErrorMessage,
        noQueryMessage,
        initialSuggestions,
        preSearchChange,
        onValueChange,
        search,
        isFocused
      };
      return {
        compProps,
        uiProps
      };
    };
    const _initialSuggestions = props.initialSuggestions ? props.serializeSuggestions(props.initialSuggestions) : [];
    this.state = {
      isFetching: false,
      suggestions: _initialSuggestions,
      selectedSuggestions: _initialSuggestions,
      error: false,
      searchQuery: null,
      open: false
    };
  }
  componentWillUnmount() {
    this.cancellableAction && this.cancellableAction.cancel();
  }
  render() {
    const {
      compProps,
      uiProps
    } = this.getProps();
    const {
      error,
      suggestions,
      open,
      isFetching
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement(SelectField, Object.assign({}, uiProps, {
      allowAdditions: error ? false : uiProps.allowAdditions,
      fieldPath: compProps.fieldPath,
      options: suggestions,
      noResultsMessage: this.getNoResultsMessage(),
      search: compProps.search,
      searchInput: {
        id: compProps.fieldPath,
        autoFocus: compProps.isFocused
      },
      lazyLoad: true,
      open: open,
      onClose: this.onClose,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onSearchChange: this.onSearchChange,
      onAddItem: _ref4 => {
        let {
          event,
          data,
          formikProps
        } = _ref4;
        this.handleAddition(event, data, selectedSuggestions => {
          if (compProps.onValueChange) {
            compProps.onValueChange({
              event,
              data,
              formikProps
            }, selectedSuggestions);
          }
        });
      },
      onChange: _ref5 => {
        let {
          event,
          data,
          formikProps
        } = _ref5;
        this.onSelectValue(event, data, selectedSuggestions => {
          if (compProps.onValueChange) {
            compProps.onValueChange({
              event,
              data,
              formikProps
            }, selectedSuggestions);
          } else {
            formikProps.form.setFieldValue(compProps.fieldPath, data.value);
          }
        });
      },
      loading: isFetching,
      className: "invenio-remote-select-field"
    }));
  }
}
RemoteSelectField.defaultProps = {
  debounceTime: 500,
  suggestionAPIQueryParams: {},
  suggestionAPIHeaders: {},
  serializeSuggestions: serializeSuggestions,
  searchQueryParamName: "suggest",
  suggestionsErrorMessage: "Something went wrong...",
  noQueryMessage: "Search...",
  noResultsMessage: "No results found.",
  loadingMessage: "Loading...",
  preSearchChange: x => x,
  search: true,
  multiple: false,
  serializeAddedValue: undefined,
  initialSuggestions: [],
  onValueChange: undefined,
  isFocused: false,
  searchOnFocus: false
};

const _excluded$9 = ["fieldPath", "error", "helpText", "disabled", "label", "optimized", "required"];
class TextField extends React.Component {
  render() {
    const _this$props = this.props,
      {
        fieldPath,
        error,
        helpText,
        disabled,
        label,
        optimized,
        required
      } = _this$props,
      uiProps = _objectWithoutProperties(_this$props, _excluded$9);
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FormikField, {
      className: "invenio-text-input-field",
      id: fieldPath,
      name: fieldPath,
      required: required,
      disabled: disabled
    }, _ref => {
      let {
        field,
        meta
      } = _ref;
      const computedError = error || meta.error ||
      // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      !meta.touched && meta.initialError;
      let formInputError = null;
      if (typeof computedError === "string") {
        formInputError = computedError;
      } else if (typeof computedError === "object" && computedError.message && computedError.severity) {
        formInputError = /*#__PURE__*/React__default["default"].createElement(FeedbackLabel, {
          errorMessage: computedError,
          pointing: "above",
          fieldPath: fieldPath
        });
      }
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Input, Object.assign({}, field, {
        error: formInputError,
        disabled: disabled,
        fluid: true,
        label: label,
        id: fieldPath,
        required: required
      }, uiProps));
    }), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, helpText));
  }
}
TextField.defaultProps = {
  error: undefined,
  helpText: "",
  disabled: false,
  optimized: false,
  required: false
};

const _excluded$8 = ["form"],
  _excluded2$2 = ["fieldPath"],
  _excluded3$1 = ["optimized", "fieldPath"];
class TextAreaField extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = _ref => {
      let {
          form
        } = _ref,
        cmpProps = _objectWithoutProperties(_ref, _excluded$8);
      const {
          fieldPath
        } = cmpProps,
        uiProps = _objectWithoutProperties(cmpProps, _excluded2$2);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
        className: "invenio-text-area-field"
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.TextArea, Object.assign({
        id: fieldPath,
        name: fieldPath,
        onChange: form.handleChange,
        onBlur: form.handleBlur,
        value: formik.getIn(form.values, fieldPath, "")
      }, uiProps)), /*#__PURE__*/React__default["default"].createElement(ErrorLabel, {
        fieldPath: fieldPath
      }));
    };
  }
  render() {
    const _this$props = this.props,
      {
        optimized,
        fieldPath
      } = _this$props,
      props = _objectWithoutProperties(_this$props, _excluded3$1);
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, Object.assign({
      id: fieldPath,
      name: fieldPath,
      component: this.renderFormField,
      fieldPath: fieldPath
    }, props));
  }
}
TextAreaField.defaultProps = {
  optimized: false
};

const _excluded$7 = ["checked", "fieldPath", "label", "labelIcon", "onChange", "value"];
class RadioField extends React.Component {
  constructor() {
    super(...arguments);
    /** Radio Formik wrapper Component */
    this.renderFormField = formikProps => {
      /** Radio Formik + Semantic-UI Field Component
       *
       * NOTE: renderFormField is run multiple times
       * TODO: might gain performance by extracting it out as own component and
       *       using class methods
       *
       * field: current Formik field (RadioField instance)
       * form: current Formik form (holds formik state that drives the UI)
       */

      const _this$props = this.props,
        {
          checked,
          fieldPath,
          label,
          labelIcon,
          onChange,
          value
        } = _this$props,
        ui = _objectWithoutProperties(_this$props, _excluded$7);
      const handleChange = (event, data) => {
        if (onChange) {
          onChange({
            event,
            data,
            formikProps
          });
        } else {
          formikProps.form.setFieldValue(fieldPath, value);
        }
      };
      const uiProps = _omit__default["default"](ui, ["optimized"]);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Radio, Object.assign({
        name: fieldPath,
        label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
          htmlFor: fieldPath,
          icon: labelIcon,
          label: label
        }),
        value: formik.getIn(formikProps.form.values, fieldPath, ""),
        checked: checked,
        onChange: handleChange,
        className: "invenio-radio-field"
      }, uiProps));
    };
  }
  render() {
    const {
      optimized,
      fieldPath
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      name: fieldPath,
      component: this.renderFormField
    });
  }
}
RadioField.defaultProps = {
  checked: false,
  label: "",
  optimized: false,
  labelIcon: "",
  onChange: undefined,
  value: ""
};

class RichEditor extends React.Component {
  render() {
    const {
      id,
      initialValue,
      disabled,
      minHeight,
      onBlur,
      onChange,
      onFocus,
      editorConfig,
      inputValue,
      onEditorChange
    } = this.props;
    const config = _objectSpread2({
      branding: false,
      menubar: false,
      statusbar: false,
      min_height: minHeight,
      content_style: "body { font-size: 14px; }",
      plugins: ["autoresize", "code", "codesample", "image", "link", "lists", "table", "wordcount"],
      contextmenu: false,
      toolbar: "blocks | bold italic link codesample blockquote image table | bullist numlist | outdent indent | wordcount | undo redo | code",
      autoresize_bottom_margin: 20,
      block_formats: "Paragraph=p; Header 1=h1; Header 2=h2; Header 3=h3",
      table_advtab: false,
      convert_urls: false
    }, editorConfig);
    return /*#__PURE__*/React__default["default"].createElement(tinymceReact.Editor, {
      initialValue: initialValue,
      value: inputValue,
      init: config,
      id: id,
      disabled: disabled,
      onBlur: onBlur,
      onFocus: onFocus,
      onChange: onChange,
      onEditorChange: onEditorChange
    });
  }
}
RichEditor.defaultProps = {
  minHeight: 250,
  initialValue: "",
  inputValue: "",
  id: undefined,
  disabled: undefined,
  onChange: undefined,
  onEditorChange: undefined,
  onBlur: undefined,
  onFocus: undefined,
  editorConfig: undefined
};

// This file is part of React-Invenio-Deposit
class RichInputField extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = formikBag => {
      const {
        fieldPath,
        label,
        required,
        className,
        editor,
        editorConfig,
        disabled,
        optimized
      } = this.props;
      const value = formik.getIn(formikBag.form.values, fieldPath, "");
      const initialValue = formik.getIn(formikBag.form.initialValues, fieldPath, "");
      const error = formik.getIn(formikBag.form.errors, fieldPath, false) ||
      // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      initialValue === value && formik.getIn(formikBag.form.initialErrors, fieldPath, false);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
        id: fieldPath,
        required: required,
        disabled: disabled,
        error: error,
        className: className
      }, /*#__PURE__*/React__default["default"].isValidElement(label) ? label : /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: fieldPath
      }, label), editor ? editor : /*#__PURE__*/React__default["default"].createElement(RichEditor, {
        initialValue: initialValue,
        inputValue: () => value // () =>  To avoid re-rendering
        ,
        optimized: optimized,
        editorConfig: editorConfig,
        onBlur: (event, editor) => {
          formikBag.form.setFieldValue(fieldPath, editor.getContent());
          formikBag.form.setFieldTouched(fieldPath, true);
        },
        disabled: disabled
      }), /*#__PURE__*/React__default["default"].createElement(ErrorLabel, {
        fieldPath: fieldPath
      }));
    };
  }
  render() {
    const {
      optimized,
      fieldPath,
      helpText
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FormikField, {
      id: fieldPath,
      name: fieldPath,
      component: this.renderFormField
    }), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, helpText));
  }
}
RichInputField.defaultProps = {
  className: "invenio-rich-input-field",
  optimized: false,
  required: false,
  label: "",
  editor: undefined,
  editorConfig: undefined,
  disabled: false,
  helpText: undefined
};

const _excluded$6 = ["onValue", "offValue", "onLabel", "offLabel", "fieldPath", "onChange"];
class ToggleField extends React.Component {
  constructor() {
    super(...arguments);
    /** Radio toggle Formik wrapper Component */
    this.renderFormField = formikProps => {
      /** Radio toggle Formik + Semantic-UI Field Component
       *
       * NOTE: renderFormField is run multiple times
       * TODO: might gain performance by extracting it out as own component and
       *       using class methods
       *
       * formikProps: current Formik props (ToggleField instance)
       */

      const _this$props = this.props,
        {
          onValue,
          offValue,
          onLabel,
          offLabel,
          fieldPath,
          onChange
        } = _this$props,
        uiProps = _objectWithoutProperties(_this$props, _excluded$6);
      const isChecked = formik.getIn(formikProps.form.values, fieldPath) === onValue;
      const handleChange = () => {
        if (isChecked) {
          formikProps.form.setFieldValue(fieldPath, offValue);
        } else {
          formikProps.form.setFieldValue(fieldPath, onValue);
        }
        if (onChange) {
          onChange({
            checked: !isChecked
          });
        }
      };
      return /*#__PURE__*/React__default["default"].createElement(RadioField, Object.assign({}, uiProps, {
        className: "invenio-toggle-field",
        toggle: true,
        fieldPath: fieldPath,
        checked: formik.getIn(formikProps.form.values, fieldPath) === onValue,
        label: formik.getIn(formikProps.form.values, fieldPath) === onValue ? onLabel : offLabel,
        onChange: handleChange
      }));
    };
  }
  render() {
    const {
      optimized,
      fieldPath
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      name: fieldPath,
      component: this.renderFormField
    });
  }
}
ToggleField.defaultProps = {
  onChange: undefined,
  optimized: true
};

class RemoveField extends React.Component {
  render() {
    const {
      removeFieldCallback,
      fieldPath,
      field,
      label
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      label: label,
      className: "mr-10"
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      content: "Remove empty fields from the form",
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
        icon: true,
        size: "mini",
        onClick: () => removeFieldCallback(field)
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "trash alternate outline"
      }))
    }));
  }
}

class ListAndFilterCustomFields extends React.Component {
  constructor(props) {
    super(props);
    this.resetFilter = () => {
      const {
        fieldsList
      } = this.props;
      this.setState({
        filteredFieldsList: fieldsList
      });
    };
    this.filter = () => {
      const {
        fieldsList
      } = this.props;
      const {
        searchPhrase,
        filter
      } = this.state;
      if (!searchPhrase && !filter) {
        this.resetFilter();
      }
      const filteredResults = Object.fromEntries(
      // eslint-disable-next-line no-unused-vars
      Object.entries(fieldsList).filter(_ref => {
        let [key, val] = _ref;
        const matchesFilter = !filter || val.section.section === filter;
        const matchesSearch = !searchPhrase || val.label.toLowerCase().includes(searchPhrase.toLowerCase());
        return matchesFilter && matchesSearch;
      }));
      this.setState({
        filteredFieldsList: filteredResults
      });
    };
    this.handleSearch = (e, _ref2) => {
      let {
        value
      } = _ref2;
      this.setState({
        searchPhrase: value
      }, () => this.filter());
    };
    this.handleDomainFilter = (e, _ref3) => {
      let {
        value
      } = _ref3;
      this.setState({
        filter: value
      }, () => this.filter());
    };
    const {
      fieldsList: _fieldsList
    } = props;
    this.state = {
      filteredFieldsList: _fieldsList,
      searchPhrase: undefined,
      filter: undefined
    };
  }
  render() {
    const {
      filteredFieldsList
    } = this.state;
    const {
      alreadyAddedFields,
      fieldPath,
      handleSelectField,
      sections
    } = this.props;
    const dropdownOptions = sections.map(section => ({
      key: section,
      text: section,
      value: section
    }));
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Segment, {
      as: semanticUiReact.Modal.Content,
      attached: "bottom ml-0"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      width: 10
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Input, {
      fluid: true,
      icon: "search",
      placeholder: "Search field names...",
      onChange: this.handleSearch
    })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "flex align-items-center"
    }, "in:", " ", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
      className: "ml-5",
      fluid: true,
      inline: true,
      clearable: true,
      selection: true,
      placeholder: "All domains",
      options: dropdownOptions,
      onChange: this.handleDomainFilter
    }))))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Content, {
      scrolling: true
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Group, {
      divided: true,
      relaxed: true
    }, Object.entries(filteredFieldsList).map(_ref4 => {
      let [key, value] = _ref4;
      const names = key.split(":");
      const isDisabled = alreadyAddedFields.includes("".concat(fieldPath, ".").concat(key));
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item, {
        key: key,
        className: isDisabled ? "pr-10 pl-10 disabled" : "clickable pr-10 pl-10",
        fieldName: key,
        field: filteredFieldsList[key],
        onClick: e => !isDisabled ? handleSelectField(e, key, value) : {}
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Header, {
        className: isDisabled ? "text-muted mb-5" : "mb-5"
      }, /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, value.label, " ", isDisabled && /*#__PURE__*/React__default["default"].createElement("span", {
        className: "right-floated"
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "checkmark",
        color: "green"
      }), " ", /*#__PURE__*/React__default["default"].createElement("span", null, " Added")))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Description, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
        width: 12
      }, value.note))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Extra, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: value.section.icon
      }), value.section.section, ": ", names[0]), value.multiple_values === true && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
        basic: true
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "list ol"
      }), " Multiple value field"), value.type === "text" && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
        basic: true
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "text cursor"
      }), " Text field"))));
    }), " ")));
  }
}
ListAndFilterCustomFields.defaultProps = {
  sections: undefined
};

/** Import function to load widget either from a specific path or local widgets
 *
 * The user defined path to import widget is of the format `@templates/<templatePath>`.
 * Note that the `@template` alias should be a correctly resolving path and it's the
 * user of this function that has to ensure that. The value is hardcoded here as the
 * dynamic import cannot rely on purely a dynamic path i.e a variable.
 */
async function importWidget(templateLoaders, _ref) {
  let {
    ui_widget: UIWidget,
    fieldPath,
    record,
    props
  } = _ref;
  let createElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let component = undefined;
  // Try import widget from user's defined templateLoaders
  for (const loader of templateLoaders) {
    try {
      var _module$default;
      const module = await loader(UIWidget);
      component = (_module$default = module.default) !== null && _module$default !== void 0 ? _module$default : module[UIWidget];
      // Component was found, stop looking.
      if (component) {
        break;
      }
    } catch (error) {
      // If the component failed to load from a loader, try other loaders first.
      continue;
    }
  }

  // Loading failed, log it and throw an error.
  if (component === undefined) {
    console.error("Failed to import default component ".concat(UIWidget, ".js"));
    throw Error("Component not found in any loader");
  }
  if (createElement) {
    return /*#__PURE__*/React__default["default"].createElement(component, _objectSpread2(_objectSpread2({}, props), {}, {
      record: record,
      key: fieldPath,
      fieldPath: fieldPath
    }));
  } else {
    return component;
  }
}

/**
 * @param config: Configuration to load widgets
 *
 * Example configuration
 *
 * {
 *  fieldPathPrefix: "mynamespace" or empty,
 *  templateLoader: UIWidget => import(`my_folder/${UIWidget}.js`),
 *  fields: [{
 *    ui_widget: "MyWidget",
 *    field: "field_id",
 *    props: {
 *      label: "My label"
 *    }
 *  }]
 * }
 *
 * @returns array fields: resolved react components
 *
 * Example return
 *
 * [
 *  <Input fieldPath={'mynamespace.field_id'} label={label} />,
 *  ...
 * ]
 *
 */
async function loadWidgetsFromConfig(_ref2) {
  let {
    templateLoaders,
    fieldPathPrefix,
    fields,
    record
  } = _ref2;
  const importWidgetsFromFolder = (templateFolder, fieldPathPrefix, fieldsConfig) => {
    const tplPromises = [];
    fieldsConfig.forEach(fieldCfg => {
      tplPromises.push(importWidget(templateFolder, _objectSpread2(_objectSpread2({}, fieldCfg), {}, {
        fieldPath: fieldPathPrefix ? "".concat(fieldPathPrefix, ".").concat(fieldCfg.field) : fieldCfg.field,
        record
      })));
    });
    return Promise.all(tplPromises);
  };
  const _fields = await importWidgetsFromFolder(templateLoaders, fieldPathPrefix, fields);
  return [..._fields];
}

const _excluded$5 = ["fieldPath", "icon", "label", "record", "templateLoaders", "addFieldCallback", "removeFieldCallback", "sections", "existingFields"];
class AddDiscoverableFieldsModal extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.handleModalOpen = () => {
      this.setState({
        modalOpen: true
      });
    };
    this.handleModalClosed = () => {
      this.setState({
        modalOpen: false
      });
    };
    this.handleSelectField = (e, fieldName, field) => {
      const {
        selectedFieldTarget: previousSelected
      } = this.state;
      if (previousSelected) {
        previousSelected.classList.toggle("selected-background");
      }
      e.currentTarget.classList.toggle("selected-background");
      const newField = {
        field: fieldName,
        props: _objectSpread2({}, field),
        ui_widget: field.ui_widget
      };
      this.setState({
        selectedField: _objectSpread2({}, newField),
        selectedFieldTarget: e.currentTarget
      });
    };
    this.handleAddField = async function () {
      let withClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      const {
        selectedField,
        addFields: prevFields,
        selectedFieldTarget,
        existingFields: prevExisting
      } = _this.state;
      const {
        fieldPath,
        templateLoaders,
        addFieldCallback
      } = _this.props;
      _this.setState({
        loading: true
      });
      selectedField["props"]["label"] = /*#__PURE__*/React__default["default"].createElement(RemoveField, {
        fieldPath: "".concat(fieldPath, ".").concat(selectedField.field),
        removeFieldCallback: _this.handleRemoveField,
        field: {
          key: "".concat(fieldPath, ".").concat(selectedField.field)
        },
        label: selectedField.props.label
      });
      const field = await importWidget(templateLoaders, _objectSpread2(_objectSpread2({}, selectedField), {}, {
        fieldPath: "".concat(fieldPath, ".").concat(selectedField.field)
      }));
      const performCallback = () => {
        const {
          addFields
        } = _this.state;
        addFieldCallback(addFields);
        _this.setState({
          addFields: []
        });
        _this.handleModalClosed();
      };
      selectedFieldTarget.classList.toggle("selected-background");
      _this.setState({
        addFields: [...prevFields, field],
        existingFields: [...prevExisting, field.key],
        selectedField: undefined,
        selectedFieldTarget: undefined,
        loading: false
      }, () => withClose ? performCallback() : null);
    };
    this.handleCancel = () => {
      const {
        addFields
      } = this.state;
      const {
        addFieldCallback
      } = this.props;
      addFieldCallback(addFields);
      this.setState({
        addFields: []
      });
      this.handleModalClosed();
    };
    this.handleRemoveField = field => {
      const {
        existingFields: prevExisting
      } = this.state;
      const {
        removeFieldCallback
      } = this.props;
      const updatedFields = prevExisting.filter(n => field.key !== n);
      this.setState({
        existingFields: [...updatedFields]
      });
      removeFieldCallback(field);
    };
    const {
      existingFields
    } = props;
    this.state = {
      modalOpen: false,
      selectedField: undefined,
      selectedFieldTarget: undefined,
      addFields: [],
      existingFields: [...existingFields],
      loading: false
    };
  }
  render() {
    const _this$props = this.props,
      {
        fieldPath,
        // injected by the custom field loader via the `field` config property
        icon,
        label,
        record,
        templateLoaders,
        addFieldCallback,
        removeFieldCallback,
        sections,
        existingFields: _
      } = _this$props,
      fieldsList = _objectWithoutProperties(_this$props, _excluded$5);
    const {
      modalOpen,
      existingFields,
      loading,
      selectedField
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      icon: true,
      labelPosition: "left",
      onClick: this.handleModalOpen
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "plus"
    }), "Add field"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal, {
      open: modalOpen
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Header, null, "Add domain specific fields"), /*#__PURE__*/React__default["default"].createElement(ListAndFilterCustomFields, {
      fieldPath: fieldPath,
      handleSelectField: this.handleSelectField,
      alreadyAddedFields: existingFields,
      fieldsList: fieldsList,
      sections: sections
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Actions, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      onClick: this.handleCancel,
      floated: "left",
      labelPosition: "left",
      content: "Close"
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      icon: true,
      labelPosition: "left",
      onClick: () => this.handleAddField(false),
      disabled: loading || !selectedField,
      loading: loading
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "plus"
    }), "Add field and continue"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      icon: true,
      labelPosition: "left",
      onClick: () => this.handleAddField(true),
      disabled: loading || !selectedField,
      loading: loading
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "plus"
    }), "Add field and close"))));
  }
}
AddDiscoverableFieldsModal.defaultProps = {
  icon: undefined,
  label: undefined,
  sections: undefined
};

const _excluded$4 = ["field", "props", "ui_widget"],
  _excluded2$1 = ["fields", "paths"];
class DiscoverFieldsSection extends React.Component {
  constructor(_props) {
    super(_props);
    this.getFieldsConfig = sectionCfg => {
      const cfg = {};
      for (const section of sectionCfg) {
        for (const fieldCfg of section.fieldsConfig) {
          const {
              field,
              props,
              ui_widget
            } = fieldCfg,
            otherCfg = _objectWithoutProperties(fieldCfg, _excluded$4);
          cfg[field] = _objectSpread2(_objectSpread2({
            ui_widget: ui_widget,
            section: section
          }, props), otherCfg);
        }
      }
      return cfg;
    };
    this.getFieldsWithValues = sectionFields => {
      const {
        tempFields,
        recordFields
      } = this.state;
      const filledFields = [];
      for (const field of sectionFields) {
        if (recordFields.includes(field.key) || tempFields.includes(field)) {
          filledFields.push(field);
        }
      }
      return filledFields;
    };
    this.getSectionOfField = field => {
      const {
        sections
      } = this.state;
      for (const section of sections) {
        if (section.fields.map(field => field.key).includes(field.key)) {
          return section.section;
        }
      }
    };
    this.addFieldCallback = fields => {
      const {
        sections: prevSections,
        tempFields: prevTempFields
      } = this.state;
      const sections = [...prevSections];
      for (const field of fields) {
        const sectionToUpdate = this.getSectionOfField(field);
        for (const section of sections) {
          if (section.section === sectionToUpdate) {
            section["fields"] = [...section.fields, field].sort((a, b) => a.key.localeCompare(b.key));
          }
        }
      }
      this.setState({
        sections: [...sections],
        tempFields: [...prevTempFields, ...fields]
      });
    };
    this.removeFieldCallback = field => {
      const {
        sections: prevSections,
        tempFields: prevTempFields
      } = this.state;
      const sections = [...prevSections];
      let tempFields = [...prevTempFields];
      const sectionToUpdate = this.getSectionOfField(field);
      for (const section of sections) {
        if (section.section === sectionToUpdate) {
          section["fields"] = section.fields.filter(n => field.key !== n.key);
          tempFields = tempFields.filter(n => field.key !== n.key);
        }
      }
      this.setState({
        sections: [...sections],
        tempFields: [...tempFields]
      });
    };
    const {
      sections: _sections,
      record
    } = _props; // sections = fields grouping, usually by domain
    console.warn(_props);
    let filled = [];
    if (record && !_isEmpty__default["default"](record.custom_fields)) {
      filled = Object.keys(record.custom_fields).map(key => "custom_fields.".concat(key));
    }
    this.state = {
      sections: _sections,
      tempFields: [],
      recordFields: filled
    };
    this.fieldsCfg = this.getFieldsConfig(_sections);
    this.sectionsList = _sections.map(section => section.section);
  }
  render() {
    const {
      templateLoaders,
      record,
      discoverSectionLabel
    } = this.props;
    const {
      sections,
      tempFields,
      recordFields
    } = this.state;
    const existingFields = [...Object.entries(tempFields).map(_ref => {
      let [key, value] = _ref;
      return value.key;
    }), ...recordFields];
    const tempFieldsPaths = tempFields.map(item => item.key);
    return /*#__PURE__*/React__default["default"].createElement(AccordionField, {
      key: "discover-fields",
      includesPaths: tempFieldsPaths,
      label: discoverSectionLabel,
      active: true,
      id: "domain-specific-fields-section"
    }, sections.map(_ref2 => {
      let {
          fields,
          paths
        } = _ref2,
        sectionConfig = _objectWithoutProperties(_ref2, _excluded2$1);
      const recordCustomFields = this.getFieldsWithValues(fields);
      if (_isEmpty__default["default"](recordCustomFields)) {
        return undefined;
      }
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: sectionConfig.section,
        className: "rel-mb-2"
      }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: sectionConfig.section,
        icon: sectionConfig.icon,
        label: sectionConfig.section
      }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Divider, {
        fitted: true,
        className: "rel-mb-1"
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "rel-ml-1"
      }, recordCustomFields));
    }), /*#__PURE__*/React__default["default"].createElement(AddDiscoverableFieldsModal, Object.assign({
      fieldPath: "custom_fields"
    }, this.fieldsCfg, {
      templateLoaders: templateLoaders,
      addFieldCallback: this.addFieldCallback,
      removeFieldCallback: this.removeFieldCallback,
      sections: this.sectionsList,
      record: record,
      existingFields: existingFields
    })));
  }
}
DiscoverFieldsSection.defaultProps = {
  discoverSectionLabel: "Domain specific fields"
};
var DiscoverFieldsSection$1 = Overridable__default["default"].component("ReactInvenioForms.DiscoverFieldsSection", DiscoverFieldsSection);

class CustomFields extends React.Component {
  constructor(props) {
    super(props);
    this.populateConfig = async () => {
      const {
        includesPaths,
        fieldPathPrefix
      } = this.props;
      try {
        const {
          sectionsConfig,
          discoverFieldsConfig
        } = await this.loadCustomFieldsWidgets();
        const sections = await Promise.all(sectionsConfig.map(async sectionCfg => {
          const paths = includesPaths(sectionCfg.fields, fieldPathPrefix);
          const widget = await this.loadSectionWidget(sectionCfg);
          return _objectSpread2(_objectSpread2({}, sectionCfg), {}, {
            paths,
            widget
          });
        })).then(values => values);
        const discoverFieldsSections = discoverFieldsConfig.map(sectionCfg => {
          const paths = includesPaths(sectionCfg.fields, fieldPathPrefix);
          return _objectSpread2(_objectSpread2({}, sectionCfg), {}, {
            paths
          });
        });
        this.setState({
          sections: sections,
          discoverFieldsSections: discoverFieldsSections
        });
      } catch (error) {
        console.error("Couldn't load custom fields widgets.", error);
      }
    };
    this.state = {
      sections: undefined,
      discoverFieldsSections: undefined
    };
  }
  componentDidMount() {
    this.populateConfig();
  }
  async loadSectionWidget(sectionCfg) {
    const {
      templateLoaders,
      record,
      includesPaths,
      fieldPathPrefix
    } = this.props;
    const paths = includesPaths(sectionCfg.fields, fieldPathPrefix);
    if (sectionCfg.ui_widget) {
      return await importWidget(templateLoaders, _objectSpread2(_objectSpread2({}, sectionCfg), {}, {
        fieldPath: undefined,
        record,
        props: {
          includesPaths: paths,
          children: sectionCfg
        }
      }), false);
    }
  }
  async loadCustomFieldsWidgets() {
    const {
      config,
      fieldPathPrefix,
      templateLoaders,
      record
    } = this.props;
    const sections = [];
    const discoverFieldsSections = []; // finds sections with discoverable fields
    for (const sectionCfg of config) {
      // Path to end user's folder defining custom fields ui widgets
      const fields = await loadWidgetsFromConfig({
        templateLoaders: templateLoaders,
        fieldPathPrefix: fieldPathPrefix,
        fields: sectionCfg.fields,
        record: record
      });
      if (sectionCfg.discoverable_fields) {
        discoverFieldsSections.push(_objectSpread2(_objectSpread2({}, sectionCfg), {}, {
          fields: fields,
          fieldsConfig: sectionCfg.fields
        }));
      } else {
        sections.push(_objectSpread2(_objectSpread2({}, sectionCfg), {}, {
          fields
        }));
      }
    }
    return {
      sectionsConfig: sections,
      discoverFieldsConfig: discoverFieldsSections
    };
  }
  render() {
    const {
      sections,
      discoverFieldsSections
    } = this.state;
    const {
      templateLoaders,
      record,
      severityChecks
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, sections && sections.map(section => {
      const {
        fields,
        paths,
        displaySection = true,
        section: sectionName,
        widget,
        id: sectionId
      } = section;
      const active = section.active !== undefined ? section.active : true;
      const Element = widget !== undefined ? widget : AccordionField;
      return displaySection ? /*#__PURE__*/React__default["default"].createElement(Element, {
        key: "section-".concat(sectionName),
        includesPaths: paths,
        severityChecks: severityChecks,
        label: sectionName,
        active: active,
        id: sectionId
      }, fields) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Container, {
        key: "custom-fields-section"
      }, fields);
    }), discoverFieldsSections && discoverFieldsSections.length > 0 && /*#__PURE__*/React__default["default"].createElement(DiscoverFieldsSection$1, {
      templateLoaders: templateLoaders,
      sections: discoverFieldsSections,
      record: record
    }));
  }
}
CustomFields.defaultProps = {
  includesPaths: fields => fields.map(field => field.key),
  severityChecks: null
};

const _excluded$3 = ["fieldPath", "required", "multiple", "placeholder", "clearable", "label", "icon", "width", "allowAdditions", "noQueryMessage", "disabled"];
class SubjectAutocompleteDropdown extends React.Component {
  constructor() {
    super(...arguments);
    this.serializeSubjects = subjects => subjects.map(subject => {
      var _subject$id, _subject$id2;
      const scheme = subject.scheme ? "(".concat(subject.scheme, ") ") : "";
      return _objectSpread2(_objectSpread2({
        text: scheme + subject.subject,
        value: (_subject$id = subject.id) !== null && _subject$id !== void 0 ? _subject$id : subject.subject,
        key: (_subject$id2 = subject.id) !== null && _subject$id2 !== void 0 ? _subject$id2 : subject.subject
      }, subject.id ? {
        id: subject.id
      } : {}), {}, {
        subject: subject.subject
      });
    });
    this.prepareSuggest = searchQuery => {
      const {
        limitTo
      } = this.props;
      return limitTo === "" || limitTo === "all" ? searchQuery : "".concat(limitTo, ":").concat(searchQuery);
    };
  }
  render() {
    const _this$props = this.props,
      {
        fieldPath,
        required,
        multiple,
        placeholder,
        clearable,
        label,
        icon,
        width,
        allowAdditions,
        noQueryMessage,
        disabled
      } = _this$props,
      uiProps = _objectWithoutProperties(_this$props, _excluded$3);
    const labelContent = label ? /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      icon: icon,
      label: label
    }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: fieldPath,
      className: "mobile-hidden",
      "aria-label": "Placeholder label for alignment purposes"
    }, "\xA0"));
    return /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      name: fieldPath
    }, _ref => {
      let {
        form: {
          values
        }
      } = _ref;
      return /*#__PURE__*/React__default["default"].createElement(RemoteSelectField, Object.assign({}, uiProps, {
        clearable: clearable,
        fieldPath: fieldPath,
        initialSuggestions: formik.getIn(values, fieldPath, []),
        multiple: multiple,
        noQueryMessage: noQueryMessage,
        placeholder: placeholder,
        preSearchChange: this.prepareSuggest,
        required: required,
        serializeSuggestions: this.serializeSubjects,
        serializeAddedValue: value => ({
          text: value,
          value: value,
          key: value,
          subject: value
        }),
        suggestionAPIUrl: "/api/subjects",
        onValueChange: (_ref2, selectedSuggestions) => {
          let {
            formikProps
          } = _ref2;
          formikProps.form.setFieldValue(fieldPath, selectedSuggestions.map(subject => ({
            subject: subject.subject,
            id: subject.id
          })));
        },
        label: labelContent,
        value: formik.getIn(values, fieldPath, []).map(val => {
          var _val$id;
          return (_val$id = val.id) !== null && _val$id !== void 0 ? _val$id : val.subject;
        }),
        allowAdditions: allowAdditions,
        width: width,
        disabled: disabled
      }));
    });
  }
}
SubjectAutocompleteDropdown.defaultProps = {
  required: false,
  limitTo: "",
  label: "",
  icon: undefined,
  multiple: true,
  clearable: true,
  placeholder: "Search for a subject by name",
  width: undefined,
  noQueryMessage: "Search or create subjects...",
  allowAdditions: true,
  disabled: false
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;

const _excluded$2 = ["hidden"],
  _excluded2 = ["id"],
  _excluded3 = ["children"];

// Props used for fields that are mandatory for all records
const mandatoryFieldCommonProps = {
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  helpText: PropTypes.string,
  placeholder: PropTypes.string
};

// Also includes props that allow not including a field in the form, which are not applicable
// to mandatory fields.
const fieldCommonProps = _objectSpread2(_objectSpread2({}, mandatoryFieldCommonProps), {}, {
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool
});

/**
 * Creates a component that de-renders when the `hidden` prop is `true`.
 * All props passed to the `ShowHideComponent` are forwarded to the child component except the `hidden` prop.
 *
 * @param Component - The child component
 * @param {string=} id - An optional OverridableID for debugging purposes
 */
const showHideComponent = (Component, id) => {
  const ShowHideComponent = _ref => {
    let {
        hidden
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded$2);
    if (props.disabled && props.required) {
      console.warn("Field component ".concat(id, " is marked as required but also disabled, so it is omitted from HTML constraint validation."));
    }
    if (hidden) return null;
    return /*#__PURE__*/React__default["default"].createElement(Component, props);
  };
  ShowHideComponent.displayName = "ShowHide(".concat(Component.displayName || Component.name, ")");
  ShowHideComponent.defaultProps = _objectSpread2({}, Component.defaultProps);
  return ShowHideComponent;
};

/**
 * Creates an overridable component with show/hide functionality based on the `hidden` prop.
 * All high-level fields in the deposit form are exported through this function, and this
 * is the only version of the component that should be exported.
 *
 * @param {string} id - The Overridable ID to use
 * @param Child - The unexported child component
 */
const showHideOverridable = (id, Child) => {
  const Component = showHideComponent(Child);
  Component.propTypes = Child.propTypes;
  return Overridable__default["default"].component(id, Component);
};

/**
 * Create a component whos Overridable ID is defined via a prop at runtime rather than pre-assigned.
 * This is necessary for custom fields, where Python will inject the Overridable ID from the user's
 * configuration, allowing features like `parametrize` to be applied also to custom fields.
 */
const showHideOverridableWithDynamicId = Widget => {
  const ShowHideWidget = showHideComponent(Widget);
  const Component = _ref2 => {
    let {
        id
      } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);
    if (id === undefined) return /*#__PURE__*/React__default["default"].createElement(ShowHideWidget, props);
    return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], Object.assign({
      id: id
    }, props), /*#__PURE__*/React__default["default"].createElement(ShowHideWidget, props));
  };
  Component.defaultProps = _objectSpread2(_objectSpread2({}, Widget.defaultProps), {}, {
    id: undefined
  });
  Component.displayName = "DynamicOverridable(".concat(Widget.displayName || Widget.name, ")");
  return Component;
};

/**
 * Override the parameters of a component (similarly to `parametrize`) using certain available
 * context variables.
 *
 * Currently, the following arguments are passed into the `propsFactory` function:
 *   - `existingProps`: the props originally passed into the component before the override
 *   - `formValues`: an object of the values in the Formik form state
 *
 * The `propsFactory` function should return an object of the props to be used for overriding the
 * specified `Component`
 *
 * This function is adapted from `react-overridable`: https://github.com/indico/react-overridable/blob/d1ecfbec9993a461717824259900eec82d59f1e0/src/overridable.js#L7-L33
 *
 * @param Component - the React component to override the parameters, as in `parametrize` from react-overridable.
 * @param {function} propsFactory - function returning the props to override the component with
 */
function parametrizeWithFormContext(Component, propsFactory) {
  const ParametrizedComponent = props => {
    const {
      values
    } = formik.useFormikContext();
    const extraProps = propsFactory({
      existingProps: props,
      formValues: values
    });

    // Store the original component in an attribute
    if (Component.originalComponent) {
      Component = Component.originalComponent;
    }

    // overrideProps override props if there is a name collision
    const _props$extraProps = _objectSpread2(_objectSpread2({}, props), extraProps),
      {
        children
      } = _props$extraProps,
      attrProps = _objectWithoutProperties(_props$extraProps, _excluded3);
    return /*#__PURE__*/React__default["default"].createElement(Component, attrProps, children);
  };
  const name = Component.displayName || Component.name;
  ParametrizedComponent.displayName = "Parametrized(".concat(name, ")");
  return ParametrizedComponent;
}

const _excluded$1 = ["description", "fieldPath", "required", "label", "icon", "clearable", "placeholder", "multiple", "autocompleteFrom", "autocompleteFromAcceptHeader", "helpText", "labelIcon", "disabled"];
class AutocompleteDropdownComponent extends React.Component {
  render() {
    const _this$props = this.props,
      {
        description,
        fieldPath,
        required,
        label,
        icon,
        clearable,
        placeholder,
        multiple,
        autocompleteFrom,
        autocompleteFromAcceptHeader,
        helpText: helpTextProp,
        labelIcon: labelIconProp,
        disabled
      } = _this$props,
      dropdownProps = _objectWithoutProperties(_this$props, _excluded$1);
    const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
    const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      icon: labelIcon,
      label: label
    }), /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      name: fieldPath
    }, _ref => {
      let {
        form: {
          values
        }
      } = _ref;
      return /*#__PURE__*/React__default["default"].createElement(RemoteSelectField, Object.assign({
        clearable: clearable,
        required: required,
        fieldPath: fieldPath,
        multiple: multiple,
        noQueryMessage: placeholder,
        placeholder: placeholder,
        suggestionAPIUrl: autocompleteFrom,
        suggestionAPIHeaders: {
          Accept: autocompleteFromAcceptHeader
        },
        disabled: disabled,
        helpText: helpText,
        serializeSuggestions: suggestions => {
          return _isArray__default["default"](suggestions) ? suggestions.map(item => ({
            text: item.title_l10n,
            value: item.id,
            key: item.id
          })) : [{
            text: suggestions.title_l10n,
            value: suggestions.id,
            key: suggestions.id
          }];
        },
        initialSuggestions: _get__default["default"](values, "ui.".concat(fieldPath), [])
      }, dropdownProps));
    }));
  }
}
AutocompleteDropdownComponent.defaultProps = {
  autocompleteFromAcceptHeader: "application/vnd.inveniordm.v1+json",
  clearable: false,
  multiple: false,
  icon: undefined,
  description: undefined
};
const AutocompleteDropdown = showHideOverridableWithDynamicId(AutocompleteDropdownComponent);

class DropdownComponent extends React.Component {
  constructor() {
    super(...arguments);
    this.serializeOptions = options => options === null || options === void 0 ? void 0 : options.map(option => ({
      text: option.title_l10n,
      value: option.id,
      key: option.id
    }));
  }
  render() {
    const {
      description,
      helpText: helpTextProp,
      placeholder,
      fieldPath,
      label,
      icon,
      labelIcon: labelIconProp,
      options,
      search,
      multiple,
      clearable,
      required,
      disabled,
      optimized
    } = this.props;
    const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
    const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;
    return /*#__PURE__*/React__default["default"].createElement(SelectField, {
      fieldPath: fieldPath,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      }),
      options: this.serializeOptions(options),
      search: search,
      "aria-label": label,
      multiple: multiple,
      disabled: disabled,
      placeholder: {
        role: "option",
        content: placeholder
      },
      clearable: clearable,
      required: required,
      defaultValue: multiple ? [] : "",
      helpText: helpText,
      optimized: optimized
    });
  }
}
DropdownComponent.defaultProps = {
  icon: undefined,
  search: false,
  multiple: false,
  clearable: true,
  description: undefined,
  optimized: true
};
const Dropdown = showHideOverridableWithDynamicId(DropdownComponent);

class RichInputComponent extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      description,
      editorConfig,
      disabled,
      helpText: helpTextProp,
      labelIcon: labelIconProp,
      optimized
    } = this.props;
    const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
    const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(RichInputField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      disabled: disabled,
      editorConfig: editorConfig,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      }),
      optimized: optimized
    }), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, helpText));
  }
}
RichInputComponent.defaultProps = {
  icon: undefined,
  editorConfig: {},
  optimized: true
};
const RichInput = showHideOverridableWithDynamicId(RichInputComponent);

class TextAreaComponent extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      description,
      rows,
      disabled,
      helpText: helpTextProp,
      labelIcon: labelIconProp
    } = this.props;
    const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
    const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(TextAreaField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      disabled: disabled,
      rows: rows,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      })
    }), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, helpText));
  }
}
TextAreaComponent.defaultProps = {
  icon: undefined,
  rows: 3
};
const TextArea = showHideOverridableWithDynamicId(TextAreaComponent);

class InputComponent extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      placeholder,
      description,
      disabled,
      type,
      helpText: helpTextProp,
      labelIcon: labelIconProp
    } = this.props;
    const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
    const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;
    return /*#__PURE__*/React__default["default"].createElement(TextField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      helpText: helpText,
      disabled: disabled,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      }),
      placeholder: placeholder,
      type: type
    });
  }
}
InputComponent.defaultProps = {
  icon: undefined,
  description: undefined,
  type: "input"
};
const Input = showHideOverridableWithDynamicId(InputComponent);

const _excluded = ["additionLabel", "description", "placeholder", "fieldPath", "label", "icon", "required", "disabled", "helpText", "labelIcon", "optimized"];
function MultiInputComponent(_ref) {
  let {
      additionLabel,
      description,
      placeholder,
      fieldPath,
      label,
      icon,
      required,
      disabled,
      helpText: helpTextProp,
      labelIcon: labelIconProp,
      optimized
    } = _ref,
    uiProps = _objectWithoutProperties(_ref, _excluded);
  const [options, setOptions] = React.useState([]);
  const {
    values
  } = formik.useFormikContext();
  const serializeValues = values => values === null || values === void 0 ? void 0 : values.map(item => ({
    text: item,
    key: item,
    value: item
  }));
  const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
  const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(SelectField, Object.assign({
    fieldPath: fieldPath,
    label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      icon: labelIcon,
      label: label
    }),
    options: serializeValues(formik.getIn(values, fieldPath, [])),
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    search: true,
    multiple: true,
    clearable: true,
    optimized: optimized,
    defaultValue: [],
    noResultsMessage: placeholder // show the placeholder to instruct user how to add new values
    ,
    additionLabel: additionLabel,
    onChange: _ref2 => {
      let {
        data,
        formikProps
      } = _ref2;
      setOptions(serializeValues(data.value));
      formikProps.form.setFieldValue(fieldPath, data.value);
    },
    allowAdditions: true,
    onAddItem: _ref3 => {
      let {
        data
      } = _ref3;
      setOptions([{
        text: data.value,
        value: data.value
      }, ...options]);
    },
    icon: null // remove the dropdown caret icon to avoid confusion
  }, uiProps)), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
    className: "helptext"
  }, helpText));
}
MultiInputComponent.defaultProps = {
  additionLabel: undefined,
  icon: undefined,
  optimized: true
};
const MultiInput = showHideOverridableWithDynamicId(MultiInputComponent);

const NumberInputComponent = props => /*#__PURE__*/React__default["default"].createElement(InputComponent, Object.assign({}, props, {
  type: "number"
}));
const NumberInput = showHideOverridableWithDynamicId(NumberInputComponent);

// This file is part of React-Invenio-Forms
function BooleanCheckboxComponent(_ref) {
  let {
    description,
    icon,
    falseLabel,
    fieldPath,
    label,
    trueLabel,
    required,
    helpText: helpTextProp,
    labelIcon: labelIconProp,
    optimized
  } = _ref;
  const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
  const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;

  // eslint-disable-next-line no-unused-vars
  const [_, meta] = formik.useField(fieldPath);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    inline: true,
    className: "mb-0"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    required: required
  }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
    htmlFor: fieldPath,
    icon: labelIcon,
    label: label
  })), /*#__PURE__*/React__default["default"].createElement(RadioField, {
    fieldPath: fieldPath,
    label: trueLabel,
    checked: meta.value === true,
    value: true,
    optimized: optimized
  }), /*#__PURE__*/React__default["default"].createElement(RadioField, {
    fieldPath: fieldPath,
    label: falseLabel,
    checked: meta.value === false,
    value: false,
    optimized: optimized
  }), meta.error && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    required: required,
    className: "error"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
    pointing: "left",
    prompt: true
  }, meta.error))), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
    className: "helptext"
  }, helpText));
}
BooleanCheckboxComponent.defaultProps = {
  icon: undefined,
  optimized: true
};
const BooleanCheckbox = showHideOverridableWithDynamicId(BooleanCheckboxComponent);

class ArrayComponent extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      description,
      disabled,
      children,
      addButtonLabel,
      defaultNewValue,
      className,
      helpText: helpTextProp,
      labelIcon: labelIconProp
    } = this.props;
    const helpText = helpTextProp !== null && helpTextProp !== void 0 ? helpTextProp : description;
    const labelIcon = labelIconProp !== null && labelIconProp !== void 0 ? labelIconProp : icon;
    return /*#__PURE__*/React__default["default"].createElement(ArrayField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      helpText: helpText,
      disabled: disabled,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      }),
      addButtonLabel: addButtonLabel,
      defaultNewValue: defaultNewValue,
      className: className
    }, children);
  }
}
ArrayComponent.defaultProps = {
  className: "",
  icon: undefined
};
const Array$1 = showHideOverridableWithDynamicId(ArrayComponent);

// This file is part of React-Invenio-Forms

/**
 * Make relative date for a given timestamp
 *
 * @param timestamp string ISO timestamp
 * @returns {string} relative date in a given language, f.e. 3 days ago
 */
const toRelativeTime = function (timestamp) {
  let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  return luxon.DateTime.fromISO(timestamp).setLocale(language).toRelative();
};

// This file is part of React-Invenio-Forms
function humanReadableBytes(bytes) {
  let decimalDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (_isNumber__default["default"](bytes)) {
    const base = decimalDisplay ? 1000 : 1024;
    const kiloBytes = base;
    const megaBytes = base * kiloBytes;
    const gigaBytes = base * megaBytes;
    if (bytes < kiloBytes) {
      return "".concat(bytes, " bytes");
    } else if (bytes < megaBytes) {
      return "".concat((bytes / kiloBytes).toFixed(2), " ").concat(decimalDisplay ? "KB" : "KiB");
    } else if (bytes < gigaBytes) {
      return "".concat((bytes / megaBytes).toFixed(2), " ").concat(decimalDisplay ? "MB" : "MiB");
    } else {
      return "".concat((bytes / gigaBytes).toFixed(2), " ").concat(decimalDisplay ? "GB" : "GiB");
    }
  }
  return "";
}

// This file is part of React-Invenio-Forms
function dropdownOptionsGenerator(dropdownOptions) {
  return dropdownOptions.map(options => {
    return {
      key: options.key,
      text: options.text,
      value: options.key,
      content: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", null, options.text), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("small", {
        className: "text-muted"
      }, options.description)))
    };
  });
}

exports.AccordionField = AccordionField;
exports.AffiliationsSuggestions = AffiliationsSuggestions;
exports.Array = Array$1;
exports.ArrayField = ArrayField;
exports.AutocompleteDropdown = AutocompleteDropdown;
exports.BaseForm = BaseForm;
exports.BooleanCheckbox = BooleanCheckbox;
exports.BooleanField = BooleanField;
exports.BulkActionsContext = BulkActionsContext;
exports.CustomFields = CustomFields;
exports.DiscoverFieldsSection = DiscoverFieldsSection$1;
exports.Dropdown = Dropdown;
exports.ErrorLabel = ErrorLabel;
exports.ErrorMessage = ErrorMessage;
exports.FeedbackLabel = FeedbackLabel;
exports.FieldLabel = FieldLabel;
exports.GridResponsiveSidebarColumn = GridResponsiveSidebarColumn;
exports.GroupField = GroupField;
exports.Image = Image;
exports.Input = Input;
exports.InputComponent = InputComponent;
exports.InvenioPopup = InvenioPopup;
exports.MultiInput = MultiInput;
exports.NumberInput = NumberInput;
exports.RadioField = RadioField;
exports.RemoteSelectField = RemoteSelectField;
exports.RichEditor = RichEditor;
exports.RichInput = RichInput;
exports.RichInputField = RichInputField;
exports.SearchResultsBulkActions = SearchResultsBulkActions;
exports.SearchResultsBulkActionsManager = SearchResultsBulkActionsManager;
exports.SearchResultsRowCheckbox = SearchResultsRowCheckbox;
exports.SelectField = SelectField;
exports.SubjectAutocompleteDropdown = SubjectAutocompleteDropdown;
exports.TextArea = TextArea;
exports.TextAreaField = TextAreaField;
exports.TextField = TextField;
exports.ToggleField = ToggleField;
exports.UserListItemCompact = UserListItemCompact;
exports.dropdownOptionsGenerator = dropdownOptionsGenerator;
exports.fieldCommonProps = fieldCommonProps;
exports.http = http;
exports.humanReadableBytes = humanReadableBytes;
exports.importWidget = importWidget;
exports.loadWidgetsFromConfig = loadWidgetsFromConfig;
exports.makeIdEntry = makeIdEntry;
exports.makeSubheader = makeSubheader;
exports.mandatoryFieldCommonProps = mandatoryFieldCommonProps;
exports.parametrizeWithFormContext = parametrizeWithFormContext;
exports.showHideOverridable = showHideOverridable;
exports.showHideOverridableWithDynamicId = showHideOverridableWithDynamicId;
exports.toRelativeTime = toRelativeTime;
exports.withCancel = withCancel;
//# sourceMappingURL=index.js.map
